import { createContext, useContext } from "react";

import type { WebBootstrapResult } from "@/features/bootstrap/bootstrap_api";

export const web_bootstrap_context =
  createContext<WebBootstrapResult | null>(null);

// 项目函数命名统一 snake_case，因此此处不采用 React 常见的 useXxx 命名。
export function use_web_bootstrap(): WebBootstrapResult {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const bootstrap = useContext(web_bootstrap_context);
  if (!bootstrap) {
    throw new Error("系统启动信息尚未初始化");
  }
  return bootstrap;
}
